define('views/content/content',[
  "globals",
  "backbone",
  "history",
  "URIjs",
  "sandbox",
  "jquery"
], function (globals, Backbone, History, URI) {
  "use strict";

  return Backbone.View.extend({

    initialize: function (options) {
      if (typeof Comments !== "undefined") this.model.set("comments", Comments);
      if (typeof Annotations !== "undefined") this.model.set("annotations", Annotations);
      this.intervalId = window.setInterval(this.handleSelection, 1000);

      this.model.on("change:highlight", this.toggleHighlights, this);
      this.model.on("change:location", this.changeLocation, this);
      this.initializePage();
    },

    events: {
      "click [data-action = highlight]" : "highlight"
    },

    changeLocation: function () {
      this.model.fetch({
        success: _.bind(this.updatePage, this),
        cache: false
      });
    },

    updatePage: function (model, response) {
      $("[data-lockcommenting]").attr("data-lockcommenting", response.lockcommenting)
      if(response.lockcommenting && $("body[data-user-role]").attr("data-user-role") != "ADMINISTRATOR") {
        $("#comments #show-form").hide();
        setTimeout(function ()  {
          $("a[data-action=reply]").hide();
          $("a[data-action=edit]").hide();
          $("a[data-action=delete]").hide();
        }, 0);
      } else {
        $("#comments #show-form").show();
        setTimeout(function ()  {
          $("a[data-action=reply]").show();
          $("a[data-action=edit]").show();
          $("a[data-action=delete]").show();
        }, 0);
      }
  
      var fragment = document.createDocumentFragment(),
               div = document.createElement("div"),
               title, heading;

      div.innerHTML = response.content;

      while (div.firstChild) {
        fragment.appendChild(div.firstChild);
      }

      heading = fragment.querySelector("h1, h2, h3, h4, h5, h6");

      if (heading) {
        title = heading.textContent;
      }

      this.$el.attr("data-library", response.library);
      this.$el.attr("data-version", response.version);
      this.$el.attr("data-language", response.language);
      this.$el.attr("data-path", response.path);

      // FIXME: Why is this necessary?
      this.model.trigger("update", model.clone().set(response));

      this.render(fragment, title, response);

      return this;
    },

    insertContent: function (fragment) {
      this.$el.empty().html(fragment);
      return this;
    },

    getFragmentPosition: function () {
      var uri = this.model.getContentURI(), position = 0;

      if (!_.isEmpty(uri.fragment())) {
        // Account both for @id and @name
        var selector = uri.hash() + ",[name=" + uri.fragment() + "]";

        if ($(selector).length) {
          position = globals.getElementPosition(selector);
        }
      }

      return position;
    },

    scrollToFragment: function () {
      $("html, body").animate({
        scrollTop: this.getFragmentPosition()
      }, "fast");

      return this;
    },

    initializePage: function () {
      if (!globals.onCoverPage()) {
        return this
          .updateCommentListLink()
          .rewritePluginsRootLinks()
          .interceptLinks()
          .cleanTables()
          .toggleHighlights()
          .prepareImages();
      } else {
        return this;
      }
    },

    // FIXME: Move into a separate view.
    updateCommentListLink: function () {
      var $el = $(".js-show-comment-list");

      if (!globals.onCoverPage()) {
        $el.removeClass("hidden").attr("href",
          $el.data("base") + "/" +
          this.$el.attr("data-library") + "/" +
          this.$el.attr("data-version") + "/" +
          this.$el.attr("data-language"));
      }

      return this;
    },

    render: function (fragment, title, response) {
      this.insertContent(fragment);
      this.model.updateHistory(title);

      this.initializePage()
          .fixImagePaths()
          .scrollToFragment();

      this.model.set({
        toc: response.toc
      });

      return this;
    },

    prepareImages: function () {
      var self = this;
      if (globals.options.ui.commentsEnabled) {
        var images = document.getElementsByTagName("main")[0].getElementsByTagName("img");
        var startCoordinates = {}, endCoordinates = {};
        for(var i = 0; i < images.length; i++) {
          images[i].id = "img-" + i;

          $(images[i]).on("click", function (e) {
            var offset = $(e.currentTarget).offset();
            if(endCoordinates.X) {
              if(document.getElementById("image-highlight") !== null) {
                $(document.getElementById("image-highlight")).remove();
                return this;
              }
              startCoordinates = {};
              endCoordinates = {};
            } else if(!startCoordinates.X) {
              startCoordinates.X = e.pageX - offset.left;
              startCoordinates.Y = e.pageY - offset.top;

              var div = document.createElement("div");
              div.id = "image-highlight";
              div.setAttribute("name", e.currentTarget.getAttribute("id"));
              div.style.setProperty("position", "absolute");
              div.style.setProperty("background", "rgba(255, 255, 0, .5)");
              div.style.setProperty("width", $(e.currentTarget).width() + "px");
              div.style.setProperty("height", $(e.currentTarget).height() + "px");

              e.currentTarget.outerHTML = div.outerHTML + e.currentTarget.outerHTML;
              $(document.getElementById("highlightbutton")).show();

              $(div).ready(function () {
                $(document.getElementById("image-highlight")).on("click", function (e) {

                  if(startCoordinates.X) {
                    endCoordinates.X = e.pageX - offset.left;
                    endCoordinates.Y = e.pageY - offset.top;
                    var width = Math.abs(endCoordinates.X - startCoordinates.X);
                    var height = Math.abs(endCoordinates.Y - startCoordinates.Y);

                    var div = document.getElementById("image-highlight");
                    div.style.setProperty("width", width + "px");
                    div.style.setProperty("height", height + "px");
                    div.style.setProperty("margin-left", Math.min(startCoordinates.X, endCoordinates.X) + "px");
                    div.style.setProperty("margin-top", Math.min(startCoordinates.Y, endCoordinates.Y) + "px");

                    startCoordinates = {};

                  } else {
                    $(e.currentTarget).remove()
                    endCoordinates = {};
                  }
                  return this;
                });

                $(document.getElementById("image-highlight")).on("remove", function (e) {
                  self.prepareImages();
                  return this;
                });
              });
            }
          });
        }
      }
      return this;
    },

    fixImagePaths: function () {
      var baseUrl = this.model.getContentURI().normalizePath().toString();

      this.$("img").each(function () {
        this.src = URI($(this).attr("src"), baseUrl).path();
      });
      this.$("iframe").each(function () {
        this.src = URI($(this).attr("src"), baseUrl).path();
      });

      return this;
    },

    cleanTables: function () {
      // These attributes mess with Bootstrap's table-related CSS. The
      // attributes are invalid HTML5, so they should actually be removed from
      // the HTML, but that'd require implementing a full-fledged DITA-OT HTML5
      // transtype, so this quick and dirty solution has to do for now.
      this.$("table[border]")
          .attr("border", 0).removeAttr("rules").removeAttr("frame").addClass("table");

      return this;
    },

    /*
     * Rewrite PLUGINS_ROOT links in the content pane.
     *
     * A PLUGINS_ROOT link looks like this:
     *
     *   PLUGINS_ROOT/org.oasis-open.dita/1.2.0/language_reference.html
     *
     * It will be rewritten to replace the PLUGINS_ROOT token with the content
     * base URI of the current instance, like so:
     *
     *   /content/org.oasis-open.dita/1.2.0/language_reference.html
     *
     * Since the content base URI depends on the instance, we can't simply
     * replace "PLUGINS_ROOT/" with a hard-coded value like "/content/".
     *
     * The PLUGINS_ROOT notation emulates the corresponding Eclipse Help
     * System feature. See:
     *
     * http://help.eclipse.org/luna/index.jsp?topic=%2Forg.eclipse.platform.doc.isv%2Fguide%2Fua_help_content_files.htm
     *
     * @returns this.
     */
    rewritePluginsRootLinks: function () {
      var base = this.model.getContentBaseURI().path();

      this.$("a[href]").each(function () {
        var href = $(this).attr("href");

        if (href.substring(0, 13) === "PLUGINS_ROOT/") {
          $(this).attr("href", base + href.substring(12));
        }
      });

      return this;
    },

    interceptLinks: function () {
      var model = this.model;

      this.$("a[href]").not(".no-intercept").on("click", function () {
        document.getElementById("contentPane").scrollTo(0,0)
        var href = $(this).closest("a").attr("href"), uri = new URI(href);

        if (uri.is("relative")) {
          model.updateLocationFromURI(uri);
          return false;
        }
      });

      return this;
    },

    toggleHighlights: function () {
      var highlights = this.model.get("highlight");

      if (this.model.has("highlight") && highlights.length) {
        this.$el.parent().highlight(highlights);
      } else {
        this.$el.unhighlight();
      }

      return this;
    },

    handleSelection: function () {
      var selectionIsValid = true;
      var selection = window.getSelection();

      if (!document.getElementById("comments")) {
        selectionIsValid = false;
      } else {
        selectionIsValid = $("#comments").is(":visible");
      }

      if (selection.toString().length < 3) {
        selectionIsValid = false;
      } else {
        var html = "";
        if (typeof window.getSelection != "undefined") {
          var sel = window.getSelection();
          if (sel.rangeCount) {
            var container = document.createElement("div");
            for (var i = 0, len = sel.rangeCount; i < len; ++i) {
              container.appendChild(sel.getRangeAt(i).cloneContents());
            }

            if (container.firstChild.data) {
              html = container.firstChild.data.trim();
            } else {
              html = container.firstChild.outerText.trim();
            }

            if (html.length < 3) html = null;
          }
        } else if (typeof document.selection != "undefined") {
          if (document.selection.type == "Text") {
            html = document.selection.createRange().htmlText;
          }
        }

        if(!html) {
          selectionIsValid = false;
        }
      }

      if (!$(document.getElementsByTagName("main")[0]).has(selection.anchorNode).length){
        selectionIsValid = false;
      }

      $(".highlight").each(function (index, element) {
        if (selection.containsNode(element, true)) {
          selectionIsValid = false;
        }
      });

      if(selectionIsValid && ($("[data-lockcommenting]").attr("data-lockcommenting") != "true" || $("body[data-user-role]").attr("data-user-role") == "ADMINISTRATOR")) {
        $(document.getElementById("highlightbutton")).show();
        if (document.getElementById("image-highlight") !== null) $(document.getElementById("image-highlight")).remove();
      } else {
        if (document.getElementById("image-highlight") === null) {
          $(document.getElementById("highlightbutton")).hide();
        }
      }

      return this;
    } 
  });
});

